<template>
  <div class="dropdown-center">
    <button
      id="dropdowFlexDriveFilterModel"
      class="form-select form-select-short"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      <div v-if="selected.length" class="form-select-wrapper">
        <div>
          <span v-if="selected.length === 1">
            {{ getOptionText(selected[0]) }}
          </span>
          <span v-else>
            {{ selected.length }}
            {{ dictionary.modelsSelectedSuffix }}
          </span>
        </div>
        <button
          type="button"
          class="btn btn-clear btn-reset"
          title="Clear"
          @click.stop="resetSelected">
          <i class="icon-close"></i>
        </button>
      </div>
      <div v-else>{{ dictionary.modelsPlaceholder }}</div>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdowFlexDriveFilterModel">
      <div class="b-fleet-filters" @click.stop>
        <div class="b-fleet-filters__body">
          <ul>
            <li v-for="item in options" :key="item.value">
              <input
                :id="item.value"
                v-model="selected"
                class="form-check-input"
                autocomplete="off"
                type="checkbox"
                :value="item.value"
                :disabled="item.disabled"
                @change="onChange" />
              <label class="form-check-label" :for="item.value" @click.stop>
                {{ item.text }} ({{ getOptionCount(item.value) }})
              </label>
            </li>
          </ul>
          <span v-if="!options.length">Επιλέξτε πρώτα μία μάρκα</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { uniqBy } from 'lodash'
import mixinsFlexDrive from './../../mixins/flexdrive-mixins'

export default {
  mixins: [mixinsFlexDrive],
  props: {
    records: {
      required: true,
      type: Array,
    },
  },
  emits: ['change-selected'],
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    options() {
      if (!this.brands.length) {
        return []
      }

      const array = this.records
        .filter((i) => this.brands.includes(i.make))
        .map((x) => ({
          value: x.model,
          text: `${x.make} ${x.model}`,
          selected: false,
          disabled: this.isDisabled(x.model),
        }))

      /* eslint-disable no-undef */
      return _.uniqBy(array, 'value')
    },
  },
  mounted() {
    this.selected = this.models
  },
  methods: {
    getOptionCount(value) {
      const data = this.getData()
      return data.filter((i) => i.model === value).length
    },

    isDisabled(value) {
      const data = this.getData()
      const exists = data.some((i) => i.model === value)
      return !exists
    },

    getData() {
      let array = this.records

      if (this.brands.length) {
        array = array.filter((i) => this.brands.includes(i.make))
      }

      if (this.fuels.length) {
        array = array.filter((i) => this.fuels.includes(i.fuelPreValue))
      }

      if (this.transmissions.length) {
        array = array.filter((i) =>
          this.transmissions.includes(i.transmissionTypePreValue)
        )
      }

      if (this.prices.length) {
        array = array.filter(
          (i) =>
            i.pricePerMonthInteger >= this.prices[0] &&
            i.pricePerMonthInteger <= this.prices[1]
        )
      }

      return array
    },

    getOptionText(value) {
      const entry = this.options.find((i) => i.value === value)

      if (!entry) {
        this.resetSelected()
        return false
      }
      return this.options.find((i) => i.value === value).text
    },

    resetSelected() {
      this.selected = []
      this.onChange()
    },

    onChange() {
      this.$emit('change-selected', this.selected)
    },
  },
}
</script>
